// Función para obtener la provincia a partir de las coordenadas
const getProvinceFromCoordinates = async ({ latitude, longitude }) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse.php?lat=` +
        latitude +
        `&lon=` +
        longitude +
        `&zoom=18&format=jsonv2`
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return {
      code: data.address["ISO3166-2-lvl4"],
      province: data.address.state,
      country: data.address.country,
    };
  } catch (error) {
    console.error("Error fetching province data:", error);
    return null;
  }
};

// Función para activar una variante
function activateVariant(optionContainer, input) {
  // Eliminar la clase que desactiva la variante
  optionContainer.classList.remove("cs-disabled");
  input.classList.remove("disabled");
  input.removeAttribute("disabled");

  // Si había un span de popup, podemos removerlo
  const notifyMeSpan = optionContainer.querySelector(".text-notifyme");
  if (notifyMeSpan) {
    notifyMeSpan.remove();
  }
}

// Función para desactivar una variante
function deactivateVariant(optionContainer, input) {
  // Agregar la clase que desactiva la variante
  optionContainer.classList.add("cs-disabled");
  input.classList.add("disabled");
  input.setAttribute("disabled", "true");

  // Si no existe el span de popup, lo agregamos
  let notifyMeSpan = optionContainer.querySelector(".text-notifyme");
  if (!notifyMeSpan) {
    notifyMeSpan = document.createElement("span");
    notifyMeSpan.style.cursor = "pointer";
    notifyMeSpan.classList.add("text-notifyme");
    notifyMeSpan.setAttribute("onclick", "openPopUpOutOfStock(this)");
    optionContainer.appendChild(notifyMeSpan);
  }
}

window.sucursalActiva = "WEB";
document.addEventListener("DOMContentLoaded", async () => {
  //------------------ buscando la posicionb --------------------------


  //console.log("00000000");

  navigator.geolocation.getCurrentPosition(async (position) => {
    const { latitude, longitude } = position.coords;


    //console.log("1111111");

    const data = await getProvinceFromCoordinates({ latitude, longitude });
    //console.log(latitude, longitude, data);

    let location = "WEB";
    if (data?.code)
      switch (data?.code) {
        case "ES-IB":
        case "ES-PM":
          location = "WEB BALEARES";
          break;
        case "ES-CN":
        case "ES-GC":
        case "ES-TF":
          location = "WEB CANARIAS";
          break;
        default:
          location = "WEB";
          break;
      }

    window.sucursalActiva = location;
    //console.log(window.sucursalActiva);

    //console.log("33333333");

    try {
      // Grid.setup();
      adjustVariantAvailabilityOnProductCards();
    } catch (error) {
      // nada que hacer, puede darse en cualquie otra pagina que no sea colecciones
    }

    // adjustProductCard();
    adjustVariantAvailabilityOnProductCards("variant-radios");
    adjustVariantAvailabilityOnProductMobileView();
  });

  //--------------------------------------------------------------
});

// Suponiendo que el productId se ha definido en Liquid y la sucursal activa está en window.sucursalActiva
async function adjustProductCard() {
  var productId = window.productId;
  if (productId !== undefined) {
    var sucursalActiva = window.sucursalActiva; // Asumiendo que la sucursal activa ya está definida
    var shopName = Shopify.shop;
    // URL de tu endpoint para obtener la disponibilidad de variantes
    const apiURL = `https://api-inventory-locations.onrender.com/product-availability/${shopName}/${productId}`; // shopName lo puedes extraer desde algún lugar o definirlo

    try {
      // Hacer fetch al endpoint de disponibilidad
      const response = await fetch(apiURL);
      const data = await response.json();
      // console.log("DATA", data);
      // Verificar el stock en la sucursal activa y activar/desactivar variantes
      data.availability.forEach((variant) => {
        const inventoryInSucursal = variant.inventory.find(
          (location) => location.name === window.sucursalActiva
        );

        // Buscar la opción de variante en el DOM usando el título de la variante
        const variantOption = document.querySelector(
          `div.option-variation label[title="${variant.title}"]`
        );

        if (variantOption) {
          const input = variantOption.previousElementSibling; // El input radio correspondiente
          const optionContainer = variantOption.closest(".option-variation");

          if (
            inventoryInSucursal &&
            inventoryInSucursal.available_quantity > 0
          ) {
            // console.log("ACTIVATE", inventoryInSucursal);
            // Variante tiene stock en la sucursal activa
            activateVariant(optionContainer, input);
          } else {
            // console.log("DESACTIVATE", inventoryInSucursal);
            // Variante no tiene stock en la sucursal activa
            deactivateVariant(optionContainer, input);
          }
        }
      });
    } catch (error) {
      console.error("Error fetching product availability:", error);
    }
  }
}
//-----------------------------------------------
//ajustando la disponibilidad en los cards del listado de productos
function adjustVariantAvailabilityOnProductCards(tipo = "variant-radios-card") {
  // Definir la sucursal activa
  const sucursalActiva = window.sucursalActiva; // Ajusta este valor según tu necesidad
  // Seleccionar el elemento que contiene las variantes y su inventario
  const variantsCard = document.querySelectorAll(tipo);

  //console.log("PRUEBAS");

  if (variantsCard) {
     //console.log("variant radios", variantCard);
    variantsCard.forEach((variant) => {
      const locInventory = JSON.parse(variant.getAttribute("data-loc-inv"));
       //console.log("Check", locInventory, locInventory !== "null");
      if (locInventory != null) {
        // Seleccionar todos los inputs de tipo radio (opciones de tallas)
        const inputs = variant.querySelectorAll('input[type="radio"]');

        // Iterar sobre cada input (opción de talla)
        inputs.forEach((input) => {
          const talla = input.value;

          // Buscar la disponibilidad de esta talla en la sucursal activa
          const variantAvailability = locInventory.find(
            (inv) =>
              inv.variant_title === talla &&
              inv.location_name === sucursalActiva
          );

           //console.log(
           //  "Disponibilidad",
           //  talla,
           //  variantAvailability?.available_quantity
           //);

          // Si hay disponibilidad, habilitar la opción; si no, deshabilitarla
          if (
            variantAvailability &&
            variantAvailability.available_quantity > 0
          ) {
            input.disabled = false;
            input.classList.remove("disabled");
            const label = variant.querySelector(`label[for="${input.id}"]`);
            if (label) {
              label.classList.remove("cs-disabled");
            }
          } else {
            input.disabled = true;
            input.classList.add("disabled");
            const label = variant.querySelector(`label[for="${input.id}"]`);
            if (label) {
              label.classList.add("cs-disabled");
            }
          }
        });
      }
    });
  }
}

//ajustando la disponibilidad en el dialog mobile
function adjustVariantAvailabilityOnProductMobileView(

  tipo = ".variant-selector"
) {
  // Definir la sucursal activa
  const sucursalActiva = window.sucursalActiva; // Ajusta este valor según tu necesidad

  // Seleccionar el elemento que contiene las variantes y su inventario
  const variantsCard = document.querySelectorAll(tipo);

  //console.log(variantsCard);

  if (variantsCard) {
    // console.log("variant radios", variantCard);

    variantsCard.forEach((variant) => {
      const locInventory = JSON.parse(variant.getAttribute("data-loc-inv"));

      if (locInventory != null) {
        // Seleccionar todos los inputs de tipo radio (opciones de tallas)
        const inputs = variant.querySelectorAll("input.product-variant-id");

        // Iterar sobre cada input (opción de talla)
        inputs.forEach((input) => {
          const talla = input.getAttribute("data-title");

          // Buscar la disponibilidad de esta talla en la sucursal activa
          const variantAvailability = locInventory.find(
            (inv) =>
              inv.variant_title === talla &&
              inv.location_name === sucursalActiva
          );

          // console.log(
          //   "Dispo-Mobile",
          //   talla,
          //   variantAvailability?.available_quantity
          // );
          const htmlBlock = `
          <span style="cursor: pointer" onclick="javascript:openPopUpOutOfStock(this)" class="text-notifyme-wrapper">
            <span class="text-notifyme">AVÍSAME CUANDO ESTÉ DISPONIBLE</span>
          </span>
        `;
          // Si hay disponibilidad, habilitar la opción; si no, deshabilitarla
          const btn = input.closest("form").querySelector("button");
          const notifyElement = input
            .closest("form")
            .querySelector(".text-notifyme-wrapper");
          if (
            variantAvailability &&
            variantAvailability.available_quantity > 0
          ) {
            // Verifica si el botón está habilitado (no tiene el atributo disabled)
            btn.classList.remove("geo-disabled");

            if (!btn.disabled && notifyElement) {
              notifyElement.remove(); // Elimina el bloque de notificación si el botón está habilitado
              btn.setAttribute("disabled", false);
            }else{
              const validateNotify = btn.querySelector('span.text-notifyme-wrapper');
              if(validateNotify) validateNotify.remove();
            }
          } else {
            btn.classList.add("geo-disabled");
            btn.setAttribute("disabled", true);
            btn.removeAttribute("onclick");

            if (!notifyElement) {
              btn.insertAdjacentHTML("afterend", htmlBlock);
            }
          }
        });
      }
    });
  }
}

//mutation
document.addEventListener("DOMContentLoaded", async () => {
  const handleProductSlideInventoryAvailable = (node = document) => {
    //console.log("NODE", node);
  };
  // Configurar el MutationObserver
  const observerProductSlide = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            handleProductSlideInventoryAvailable(node);
          }
        });
      }
    });
  });

  // Iniciar la observación si productRelated existe
  const targetSlide = document.querySelector("slider-component");
  if (targetSlide)
    observerProductSlide.observe(targetSlide, {
      childList: true,
      subtree: true,
    });
});